import { useEffect } from "react";
import { Link } from "react-router-dom";
import AnimatedBackground from "../../common/AnimatedBackground";
import SEOHead from "../../common/SEOHead";
import Footer from "../Footer/Footer";

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative w-full min-h-lvh text-white flex flex-col">
      <SEOHead
        title="Términos y Condiciones"
        description="Términos de uso de martinofranco.com para navegación, contenido y contacto."
        url="/terms"
      />
      <AnimatedBackground />

      <main className="relative flex-1 max-w-4xl mx-auto w-full px-6 sm:px-12 py-10">
        <h1 className="text-3xl sm:text-4xl font-bold font-header text-white mb-3">
          Términos y Condiciones
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Última actualización: 9 de abril de 2026.
        </p>

        <div className="h-px bg-gray-700/60 mb-8" />

        <div className="prose-blog text-gray-300 leading-relaxed">
          <p>
            Al acceder y utilizar martinofranco.com (en adelante, "el sitio"),
            aceptás estos términos de uso en su totalidad. Si no estás de acuerdo
            con alguna parte, te recomendamos no usar el sitio. El acceso y uso
            del sitio implica la aceptación plena y sin reservas de estos términos.
          </p>

          <h2>1. Objeto del sitio</h2>
          <p>
            martinofranco.com es un sitio web de carácter personal y profesional
            administrado por Franco Martino. Su propósito es publicar información
            sobre proyectos de desarrollo de software, artículos técnicos,
            experiencias profesionales, recursos educativos y medios de contacto.
            El contenido está dirigido a desarrolladores, estudiantes, profesionales
            del sector tecnológico y cualquier persona interesada en los temas
            publicados.
          </p>

          <h2>2. Uso permitido</h2>
          <p>Como usuario del sitio, aceptás:</p>
          <ul>
            <li>Utilizar el sitio exclusivamente con fines informativos, profesionales y educativos.</li>
            <li>No realizar actividades que puedan comprometer la seguridad, integridad o disponibilidad del sitio.</li>
            <li>
              No copiar, reproducir, distribuir, modificar o crear obras derivadas del contenido sin autorización previa, excepto cuando esté expresamente indicado como contenido abierto o bajo licencia permisiva.
            </li>
            <li>No utilizar el sitio para enviar contenido malicioso, spam o realizar actividades fraudulentas.</li>
            <li>Respetar los derechos de propiedad intelectual del titular y de terceros.</li>
          </ul>
          <p>El incumplimiento de estas condiciones puede resultar en la restricción del acceso al sitio.</p>

          <h2>3. Propiedad intelectual</h2>
          <p>
            Salvo indicación expresa en contrario, todo el contenido publicado en el sitio —incluyendo pero no limitado a textos, estructura de navegación, diseño visual, logotipos, ilustraciones, imágenes y código fuente— es propiedad de Franco Martino o se utiliza bajo licencias que permiten su uso en este contexto.
          </p>
          <p>
            El código fuente de los proyectos open-source mencionados en el sitio se rige por las licencias específicas indicadas en sus respectivos repositorios. Las marcas comerciales, nombres de productos y servicios de terceros que puedan mencionarse pertenecen a sus respectivos titulares.
          </p>

          <h2>4. Exactitud de la información</h2>
          <p>
            El contenido publicado en el sitio se elabora de buena fe con fines educativos, divulgativos y de documentación técnica. Si bien se realiza un esfuerzo razonable para mantener la información actualizada, completa y precisa, no se garantiza la ausencia total de errores, omisiones o desactualizaciones. El usuario asume la responsabilidad de verificar la información antes de aplicarla en contextos profesionales o críticos.
          </p>

          <h2>5. Enlaces a terceros</h2>
          <p>
            Este sitio puede incluir enlaces a sitios web o plataformas externas (por ejemplo, GitHub, LinkedIn, herramientas mencionadas en artículos, entre otros). Estos enlaces se proporcionan únicamente como referencia o utilidad para el usuario. No se controla, supervisa ni asume responsabilidad por el contenido, políticas de privacidad, prácticas o disponibilidad de dichos sitios externos.
          </p>

          <h2>6. Publicidad</h2>
          <p>
            El sitio puede mostrar anuncios gestionados por terceros, incluyendo Google AdSense. La presencia de anuncios en el sitio no implica recomendación, aval o responsabilidad por parte del titular respecto de los productos, servicios o contenidos promocionados. Los anuncios se identifican claramente como contenido publicitario.
          </p>

          <h2>7. Limitación de responsabilidad</h2>
          <p>
            En la máxima medida permitida por la legislación aplicable, el titular del sitio no será responsable por daños directos, indirectos, incidentales, consecuentes o punitivos derivados del uso o la imposibilidad de uso del sitio, su contenido, o cualquier enlace externo incluido en él. Esto incluye, entre otros, pérdida de datos, pérdida de oportunidades comerciales o interrupción del servicio.
          </p>

          <h2>8. Legislación aplicable</h2>
          <p>
            Estos términos se rigen por las leyes de la República Argentina. Cualquier controversia que derive de estos términos o del uso del sitio será sometida a los tribunales competentes de la Ciudad Autónoma de Buenos Aires.
          </p>

          <h2>9. Modificaciones</h2>
          <p>
            Estos términos pueden actualizarse en cualquier momento para reflejar cambios en el funcionamiento del sitio, requisitos legales o prácticas recomendadas. Las modificaciones entrarán en vigor inmediatamente después de su publicación en esta página. El uso continuado del sitio tras una modificación implica la aceptación de la versión vigente de los términos. Se recomienda revisar esta página periódicamente.
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="text-gray-500 hover:text-white text-sm transition-colors duration-200 underline underline-offset-4"
          >
            ← Volver al portfolio
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}